<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.progress_evaluation'),
                        href: meta.links.index,
                    },
                    {
                        name: progressEvaluation.category_name,
                        href: meta.links.category_index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <input type="hidden" name="group_id" :value="form.group_id" />
            <input type="hidden" name="progress_evaluation_id" :value="form.progress_evaluation_id" />

            <ProgressEvaluationScoresForm
                v-model:date-input="form.date"
                v-model:max-score-input="form.max_score"
                v-model:progress-evaluation-group-scores-input="form.scores"
            />

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import ProgressEvaluationScoresForm from '@/components/pageSpecific/ProgressEvaluationScoresForm.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        ProgressEvaluationScoresForm,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'group', 'progressEvaluation', 'scores'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.group.id,
                date: this.meta.defaults.date,
                max_score: this.progressEvaluation.max_score,
                progress_evaluation_id: this.progressEvaluation.id,
                scores: this.scores,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
